<template>
  <div style="background: #eee">
    <van-sticky>
      <van-nav-bar title="其他费用详情" left-text="返回" left-arrow @click-left="goback" />
    </van-sticky>

    <MobileTablePro :columns="columns" :data="orderList" :loading="loading" :has-more="false" @load="onLoad"
      :sticky-header="stickyHeader" :show-tooltip="showTooltip">
      <template #cell-incentiveType="{ row }">
        <span>{{ row.incentiveType == 1 ? "正激励" : "负激励" }}</span>
      </template>
      <template #cell-attachmentIds="{ row }">
        <span style="text-decoration: underline; color: #1989fa" v-if="row.attachmentIds && row.attachmentIds > 0"
          @click="seeFile(row)">{{ row.attachmentIds.split(",").length }}</span>
        <span v-else>无</span>
      </template>
    </MobileTablePro>
  </div>
</template>
<script>
import MobileTablePro from "@/components/MobileTablePro.vue";
export default {
  name: "InstallPage",
  components: { MobileTablePro },
  data() {
    return {
      loading: false,
      finished: false,
      orderList: [],
      columns: [
        { key: "serialNumber", title: "序号", width: "50px", fixed: "left" },
        { key: "incentiveType", title: "正/负", width: "80px" },
        { key: "amount", title: "金额", width: "60px" },
        { key: "remark", title: "备注" },
        { key: "attachmentIds", title: "附件" },
        { key: "responsibleUserIdStr", title: "对应师傅", width: "80px" },
      ],
      stickyHeader: true,
      showTooltip: true,
    };
  },
  methods: {
    seeFile(item) {
      this.$router.push({
        path: "/settlement/fileList",
        query: {
          attachmentIds: item.attachmentIds,
        },
      });
    },
    goback() {
      //返回上一页
      this.$router.go(-1);
    },
    onLoad() {
      this.finished = false;
      this.getPageData();
    },
    getPageData() {
      //获取分页数据
      this.axios({
        url: "/v1/web/settlement-manage/settlement-order/h5/listModuleDetail",
        method: "get",
        params: {
          id: this.$route.query.id,
          module: "settlementOtherFeeList",
        },
      }).then((res) => {
        this.orderList = res.data.data.settlementOtherFeeList;
        this.orderList.forEach((item, index) => {
          item.serialNumber = index + 1;
        });
        this.loading = false;
        this.finished = true;
      });
    },
  },
};
</script>
